<template>
  <section class="login">
    <div
      class="background"
      :style="{ 'background-color': themeConfig.bg_color }"
    ></div>
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="
            content-wrapper
            d-flex
            align-items-center
            justify-content-center
            auth
            theme-one
          "
        >
          <div class="row w-100">
            <div class="col-lg-4 mx-auto">
              <div class="auto-form-wrapper">
                <b-overlay :show="showLoading">
                  <div v-if="themeConfig.logo_url" class="text-center mb-3">
                    <img class="logo-img" :src="themeConfig.logo_url" />
                  </div>
                  <div class="text-center mb-3">
                    <h4>{{ organizationName }} 管理後台</h4>
                  </div>
                  <form @submit.prevent>
                    <validation-error-alert
                      v-if="validationErrors"
                      :errors="validationErrors"
                    ></validation-error-alert>
                    <!-- <div class="form-group">
											<label class="label">登入方式</label>
											<select class="form-control" v-model="authenticateMethod">
												<option value="email">E-Mail</option>
												<option value="employee_code">員工編號</option>
											</select>
										</div> -->
                    <div class="form-group">
                      <label class="label">{{ authFieldName }}</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="'請輸入' + authFieldName"
                          v-model="form.auth_field"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <!-- <i class="mdi mdi-check-circle-outline"></i> -->
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="label">密碼</label>
                      <div class="input-group">
                        <input
                          type="password"
                          class="form-control"
                          placeholder="請輸入密碼"
                          v-model="form.password"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <!-- <i class="mdi mdi-check-circle-outline"></i> -->
                          </span>
                        </div>
                      </div>
                    </div>
                    <vue-turnstile
                      v-if="themeConfig.enable_captcha"
                      class="mb-2"
                      :site-key="siteKey"
                      theme="light"
                      @verified="token = $event"
                    />
                    <div class="form-group">
                      <button
                        class="btn btn-primary submit-btn btn-block"
                        @click="submit"
                        :disabled="isSubmitting"
                      >
                        登入
                      </button>
                    </div>
                  </form>
                </b-overlay>
              </div>
              <p v-if="footerText" class="footer-text text-center">
                {{ footerText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueTurnstile from '@/components/VueTurnstile';
import https from '@/apis/https';

import { mapState } from "vuex";
export default {
  components: { VueTurnstile },
  data() {
    return {
      showLoading: false,
      isSubmitting: false,
      validationErrors: null,
      form: {
        auth_field: null,
        password: null,
      },
      siteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
      token: null,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      organizationThemeConfig: (state) => state.organizationThemeConfig,
    }),
    authenticateMethod() {
      const allowedMethods = ["employee_code", "email"];
      const loginIdentifier = this.themeConfig?.login_identifiers;

      return allowedMethods.includes(loginIdentifier)
        ? loginIdentifier
        : "employee_code";
    },
    authFieldName() {
      return this.authenticateMethod === "email" ? "E-Mail" : "帳號";
    },
    organizationName() {
      return this.organization ? this.organization.name : "Waltily";
    },
    themeConfig() {
      if (this.organizationThemeConfig.auth) {
        return this.organizationThemeConfig.auth;
      } else {
        return {
          bg_color: "#4c4c4c",
          logo_url: null,
          og_title: null,
          og_favicon_url: null,
          enable_captcha: false,
        };
      }
    },
    footerText() {
      return this.organizationThemeConfig?.auth?.footer_text
    },
  },
  async mounted() {
    if (
      this.themeConfig.og_title !== null ||
      this.themeConfig.og_title !== undefined
    ) {
      document.title = this.themeConfig.og_title;
    } else {
      document.title = "";
    }

    if (
      this.themeConfig.og_favicon_url !== null ||
      this.themeConfig.og_favicon_url !== undefined
    ) {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = this.themeConfig.og_favicon_url;
    }

    await this.checkIpRestriction();

    const logoutSuccess = this.$route.query.logoutSuccess;

    if (logoutSuccess) {

      switch (logoutSuccess) {
        case "1":
          this.validationErrors = ["您已成功登出"];
          break;
        case "2":
          this.validationErrors = ["閒置過久，已登出"];
          break;
      }

      this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: { ...this.$route.query, logoutSuccess: undefined },
        });
    }
  },
  methods: {
    /**
     * 進入登入頁時，先向後端查詢當前 IP 是否有權存取。
     * IP 不在允許清單或在拒絕清單時，自動跳轉至 access-denied 頁面。
     */
    async checkIpRestriction() {
      this.showLoading = true;
      try {
        const orgCode = this.$route.params.org_code;
        const res = await https.get(`/${orgCode}/auth/ip-check`);
        if (!res.data.allowed) {
          const denied = res.data?.denied ?? {};
          this.$store.commit('general/SET_ACCESS_DENIED_PAYLOAD', {
            title: denied.title ?? '',
            message: denied.message ?? '',
            login_ip: denied.login_ip ?? '',
            login_time: denied.login_time ?? '',
            reason: denied.reason ?? '',
          });
          this.$router.replace({
            name: 'AuthAccessDenied',
            params: { org_code: orgCode },
          });
          return;
        }
      } catch (e) {
        // ip-check API 失敗時視為沒有限制，直接放行
        console.error('[ip-check] 失敗，視為放行', e);
      } finally {
        this.showLoading = false;
      }
    },
    async submit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.showLoading = true;
      const authMethod = this.authenticateMethod;
      const params = {
        password: this.form.password,
        org_id: this.organization.id,
        auth_method: authMethod,
      };
      params[authMethod] = this.form.auth_field;

      if (this.themeConfig.enable_captcha) {
        params.turnstile_token = this.token;
      }

      await this.$store
        .dispatch("auth/login", params)
        .then((payload) => {
          if (payload && payload.require_otp) {
            sessionStorage.setItem("otp_context", JSON.stringify(payload));
            this.$router.push({
              name: "AuthVerify",
              params: { org_code: this.$route.params.org_code },
            });
          } else {
            this.$router.push({
              name: "DashboardJump",
              params: { org_code: this.$route.params.org_code },
            });
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response && error.response.status) {
            switch (error.response.status) {
              case 422:
                this.validationErrors = error.response.data.message;
                break;
              default:
                this.$swal("失敗", error.response.data.message, "error");
                break;
            }
          }
        })
        .finally(() => {
          this.isSubmitting = false;
          this.showLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.background {
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.logo-img {
  width: 150px;
}

::v-deep .validation-error-alert {
  list-style: none;
}
</style>
